import api from "@/services/api";

const state = {
    summary: null,
    transactions: []
};

const mutations = {
    SET_REPORT(state, data) {
        state.summary = data.summary;
        state.transactions = data.transactions;
    }
};

const actions = {

    async getReport({ commit }, params = {}) {
        try {
            const res = await api.get("/reports", { params });
            commit("SET_REPORT", res.data);
        } catch (error) {
            console.error("Error fetching report:", error.message);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};